import { Component, Inject, OnInit } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ProDefiniciones } from '@shared/interfaces/request/proDefiniciones';

@Component({
  selector: 'app-definiciones-form',
  templateUrl: './definiciones-form.component.html',
  styleUrls: ['./definiciones-form.component.css']
})
export class DefinicionesFormComponent implements OnInit {
  public breakpoint: number;
  public tasas: any[];
  public conceptos: any[];

  //#region Booleanos

  public loading: boolean;
  public formPrincipal: boolean = true;
  public formApertura: boolean;
  public formGastos: boolean;
  public formBonificacion: boolean;
  public formLiquidacion: boolean;
  public formExtraordinarios: boolean;
  public formSubsidio: boolean;
  public formCargosCierre: boolean;
  public formCargosPago: boolean;
  public formIntereses: boolean;
  //#endregion

  constructor(private _dialogRef: MatDialogRef<DefinicionesFormComponent>, @Inject(MAT_DIALOG_DATA) public model: ProDefiniciones) {
    if (model) this.onUpdateForm(model.numVar);
  }

  ngOnInit() {
    this.onBreakPonit();
  }

  //#region ChangeForm

  changeBoolean(change: string) {
    console.log(change, 'change');
    switch (change) {
      case 'form':
        this.formApertura = false;
        this.formGastos = false;
        this.formPrincipal = true;
        break;
      case 'apertura':
        this.formPrincipal = false;
        this.formApertura = true;
        break;
      case 'gastos':
        this.formPrincipal = false;
        this.formGastos = true;
        break;
      case 'bonificacion':
        this.formPrincipal = false;
        this.formBonificacion = true;
        break;
      case 'liquidacion':
        this.formPrincipal = false;
        this.formLiquidacion = true;
        break;
      case 'extraordinarios':
        this.formPrincipal = false;
        this.formExtraordinarios = true;
        break;
      case 'subsidio':
        this.formPrincipal = false;
        this.formSubsidio = true;
        break;
      case 'cargosCierre':
        this.formPrincipal = false;
        this.formCargosCierre = true;
        break;
      case 'cargosPago':
        this.formPrincipal = false;
        this.formCargosPago = true;
        break;
      case 'intereses':
        this.formPrincipal = false;
        this.formIntereses = true;
        break;
    }
  }

  //#endregion

  //#region Options

  onUpdateForm(numVar: number) {
    console.log(numVar, 'numVar');
    if (numVar >= 601 && numVar <= 700) {
        console.log('cargosPago');
    } 
    if (numVar >= 3 && numVar <= 99) this.changeBoolean('apertura');
    if (numVar >= 100 && numVar <= 200) this.changeBoolean('gastos');
    if (numVar >= 201 && numVar <= 300) this.changeBoolean('bonificacion');
    if (numVar >= 301 && numVar <= 400) this.changeBoolean('liquidacion');
    if (numVar >= 401 && numVar <= 450) this.changeBoolean('extraordinarios');
    if (numVar >= 451 && numVar <= 500) this.changeBoolean('subsidio');
    if (numVar >= 501 && numVar <= 600) this.changeBoolean('cargosCierre');
    if (numVar >= 601 && numVar <= 700) this.changeBoolean('cargosPago');
    if (numVar >= 701 && numVar <= 800) this.changeBoolean('intereses');
  }

  onBreakPonit() {
    this.breakpoint = window.innerWidth <= 400 ? 1 : 2;
  }

  onResize(event) {
    this.breakpoint = event.target.innerWidth <= 400 ? 1 : 2;
  }

  close() {
    this._dialogRef.close();
  }

  //#endregion
}
